import Passportization from './container'

export default Passportization
